export class User {
    constructor(id, rolId, foreman, name, image) {
        this.id = id;
        this.rolId = rolId;
        this.foreman = foreman;
        this.name = name;
        this.image = image;
    }
    toJSON() {
        return {
            id: this.id,
            rolId: this.rolId,
            foreman: this.foreman,
            name: this.name,
            image: this.image,
        };
    }
}
